import { render, staticRenderFns } from "./dataTitle.vue?vue&type=template&id=75bbd6f4&scoped=true&"
import script from "./dataTitle.vue?vue&type=script&lang=js&"
export * from "./dataTitle.vue?vue&type=script&lang=js&"
import style0 from "./dataTitle.vue?vue&type=style&index=0&id=75bbd6f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bbd6f4",
  null
  
)

export default component.exports